import React, { FC, useEffect } from "react";
import { Button, Table, Input, Upload, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { DetailType } from "@/types/ScmEnums";
import { usePurchasePoDetailsModel } from "./purchasePoDetailsModel";
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IPurchasePoFields, IDetailList, IPurchasePoDetail, IPurchasePoSearch, Detailed } from "../../purchasePoType"
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { warehouseService, IShelfFileds } from "../../../../base/warehouse/warehouseService"
import { importPropsConfig } from "@/utils/importFile";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailDataSource,
        detaiAddDataRowKeys,
        detailLookList,
        detailAddList,
        detailDataRowKeys,
        detailDataRow,
        shelfAllList,
        detailAddForm,
        detailEditForm,
        getDetailEditOne,
        onExport,
        setShelfAllList,
        modelScreenMethod,
        setDetailDataRow,
        setDetailDataRowKeys,
        detailDetailList,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
        setAddModalVisible,
        setDetailDataSource,
        setDetailAddList,
        setMaterialHistoryRow,
        setMaterialHistoryModel,
        taxincluded, setTaxincluded
    } = usePurchasePoDetailsModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale, warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const importCallback = async (list: any) => {
        console.log(list)
        let newList = list.map((item: any) => {
            return {
                ...item,

            }
        })
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailAddList, mode)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailDataSource, mode)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        }
    }
    const action = mode == DetailType.look ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setAddModalVisible(true)}
        >{Locale["Add Material"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { detailDetailList(mode) }}
        >{Locale["Delete Material"]}</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/purchase/details/import`, importCallback)}>
            <Button className="mr-5" type="link" shape="round">{Locale["Import Details"]}</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { onExport() }}
        >{Locale["Download template"]}</Button>
    </>;
    const wsChanges = async (value: string, option: ISelectOption, record: IDetailList) => {
        await setShelfAllList([])
        console.log(option, value, record)
        let params = {
            pageSize: 1000,
            pageNum: 1,
            warehouseCode: value
        }
        const { retData } = await warehouseService.shelfPage(params)
        const { records, ...pg } = retData;
        const newRecords = records.map((item: IShelfFileds) => { return { ...item, name: item.code } })
        setShelfAllList(newRecords)
    }
    const setHistoryDetail = (record: any) => {
        setMaterialHistoryRow(record)
        setMaterialHistoryModel(true)
    }
    const columns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (t: string, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编号',
            title: Locale["Material Code"],
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p onClick={() => setHistoryDetail(record)} className="ellipsis click-span">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'materialNameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            dataIndex: 'materialName',
            width: 160,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品品牌',
            title: Locale["Material Brand"],
            width: 160,
            dataIndex: 'brandCode',
            // render:(text:any)=>
            render: (text: any) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)?.[0]?.name : getTreeNodeOne(text)?.[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '采购数量',
            title: Locale["Purchase Qty"],
            dataIndex: 'num',
            editable: mode != "look" ? true : false,
            width: 120,
        }, {
            // title: '采购单价',
            title: Locale["Unit Price"],
            dataIndex: 'price',
            editable: mode != "look" ? true : false,
            width: 150,
        },
        ...((taxincluded) => {
            return taxincluded ? [{
                title: '含税单价',
                // title: Locale["Unit Price"],
                dataIndex: 'taxPrice',
                width: 150,
                // editable: mode != "look" ? true : false,
            }] : []
        })(taxincluded),
        {
            // title: '采购金额',
            title: Locale["Purchase Amount"],
            dataIndex: 'amount',
            width: 150,

        }, {

            // title: '仓库',
            width: 200,
            title: Locale["Warehouse"],
            dataIndex: 'warehouseCode',
            editable: mode != "look" ? true : false,
            editType: "select",
            onSelectChange: wsChanges,
            options: transOptions(warehouseList),
            // rules: [{ required: true, message: "请选择仓库" }],
            render: (text: string) => transOptions(warehouseList).find(item => item.value === text)?.label ?? text,

        }, {
            // title: '货位',
            title: Locale["Shelf"],
            dataIndex: 'shelfCode',
            editable: mode != "look" ? true : false,
            editType: "select",
            allowClear: true,
            // rules: [{ required: true, message: "请选择货位" }],
            options: transOptions(shelfAllList),
            width: 160,
        }, {
            // title: '备注',
            title: Locale["Note"],
            dataIndex: 'note',
            width: 150,
        }
    ];

    const newSelectColumns = () =>
        columns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    allowClear: col?.allowClear,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })
    const handleSave = (row: IDetailList) => {
        let { num, price, taxPrice, amount, } = row
        let { taxRateCode } = mode == "add" ? detailAddForm : detailEditForm;

        num = +formatNum(num);
        price = +formatNum(price);
        taxPrice = +formatNum(taxincluded ? Number(price) * Number(taxRateCode) : price);
        amount = +formatNum(amount);

        let newRow = {
            ...row,
            warehouseName: getFindItem(row.warehouseCode as string, warehouseList)?.name,
            shelfId: getFindItem(row.shelfCode as string, shelfAllList)?.id ?? row.shelfId,
            num,
            price,
            taxPrice,
            amount: +formatNum(num * taxPrice)
        }
        console.log(getFindItem(row.shelfCode as string, shelfAllList), row, shelfAllList, row.shelfCode)
        let newData = mode == "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.materialCode === item.materialCode);
        const item = newData[index];

        //判断仓库变化时，  重置货位
        if (newRow.warehouseCode !== newData[index].warehouseCode) {
            newRow.shelfCode = undefined
        }
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
    }
    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title={Locale["Purchase Details"]} rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.materialCode as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode == DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                columns={newSelectColumns() as ColumnsType<IDetailList>}
                dataSource={typeList[mode]}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}